import { Props as SelectProps } from "react-select";

import { Option } from "@/@types/generics/Option";
import { quarters } from "@/utils/quarters";

import { SelectComponent } from "../SelectComponent";

type Props = SelectProps;

export const quarterOptions: Option<string>[] = quarters().map((quarter) => {
	return {
		value: quarter,
		label: quarter.split("/").join(" - "),
	};
});

export function QuartersSelect({ ...rest }: Props) {
	return (
		<div className="d-flex flex-column">
			<label htmlFor={rest.id} className="form-label">
				Quadrimestres:
			</label>
			<SelectComponent
				id={rest.id}
				placeholder="Selecione..."
				noOptionsMessage={() => "Nenhum quadrimestre encontrado"}
				options={quarterOptions}
				{...rest}
			/>
		</div>
	);
}
